// Time range constants
export const DEFAULT_MONTH_RANGE = 6;

// Date formatting constants
export const TRIM_CURRENT_DATE = 16;

// Index constants
export const FIRST_INDEX = 0;

// Status color mapping
export const STATUS_COLORS = {
  Active: "bg-green-400",
  Disabled: "bg-red-400",
  "On Hold": "bg-gray-400",
};

// File types
export const ACCEPTED_FILE_TYPES = ["csv", "xls", "xlsx"];

// Store pagination constants
export const STORE_LIMIT = 50;

// Pinning configuration
export const PINNING_INITIAL_STATE = ["pin"];

// Table height configuration
export const MAX_TABLE_HEIGHT = "calc(100dvh - 330px)";
export const PINNED_ROW_HEIGHT = 85;

// Filter configuration
export const FILTER_DISPLAY_VALUES = {};
export const SELECTED_FILTERS_DISPLAY = {};
export const FILTERS = {};
export const SHOW_FILTER = false;

